/**
 * @generated SignedSource<<c09efc7c02e0f66bb986d54be87f38f5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleDateContent$data = {
  readonly createdDate: number | null;
  readonly publishedDate: number | null;
  readonly updatedDate: number | null;
  readonly " $fragmentType": "articleDateContent";
};
export type articleDateContent$key = {
  readonly " $data"?: articleDateContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleDateContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleDateContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedDate",
      "storageKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "15449988738d295fcf7ddea1fec4f545";

export default node;
